 
// ================== LOGIN/LOGOUT ==================== //
import { Login } from './Login'; 


// ================== PRODUTO ==================== //
import { ListProduto } from './list/ListProduto'; 
import { AddProduto } from './add/AddProduto'; 
import { AlterProduto } from './alter/AlterProduto'; 
import { DeleteProduto } from './delete/DeleteProduto'; 

// ================== CATEGORIA ==================== //
import { ListCategoria } from './list/ListCategoria'; 
import { AddCategoria } from './add/AddCategoria'; 
import { AlterCategoria } from './alter/AlterCategoria'; 
import { DeleteCategoria } from './delete/DeleteCategoria'; 


// ================== MESA ==================== //
import { ListMesa } from './list/ListMesa'; 
import { ListMesaPedido } from './list/ListMesaPedido'; 
import { AddMesa } from './add/AddMesa'; 
import { AlterMesa } from './alter/AlterMesa'; 
import { DeleteMesa } from './delete/DeleteMesa'; 

// ================== USER ==================== //
import { ListUserId } from './list/ListUserId'; 
 import { ListUser } from './list/ListUser'; 
import { AddUser } from './add/AddUser'; 
import { AlterUser } from './alter/AlterUser'; 
import { DeleteUser } from './delete/DeleteUser'

// ================== PEDIDO ==================== //
import { CountPedidos } from './list/CountPedidos'; 
import { ListPedido } from './list/ListPedido';
import { ListPedidoPorMesa } from './list/ListPedidoPorMesa'; 
import { AlterPedido } from './alter/AlterPedido'; 
import { AddPedido } from './add/AddPedido'; 
import { ListPedidoMesa } from './list/ListPedidoMesa'; 
import { FecharPedido } from './alter/FecharPedido'; 
import { CancelarPedido } from './alter/CancelarPedido'; 
import { CancelarPedidoOnly } from './alter/CancelarPedidoOnly'; 
import { PendenteAll } from './alter/PendenteAll'; 
import { CheckPedido } from './other/CheckPedido'; 
import { EnviarCozinha } from './alter/EnviarCozinha'; 
import { EntregarProduto } from './alter/EntregarProduto'; 
import { ListPedidoCancelado } from './list/ListPedidoCancelado';
import { ListPedidoCozinha } from './list/ListPedidoCozinha';

// ================== QUANTIDADE ==================== //
import { AlterQtd } from './alter/AlterQtd'; 


// ================== OTHER ==================== //
import { MaisVendidos } from './other/MaisVendidos'; 
import { UltimosPedidos } from './other/UltimosPedidos'; 
import { DasboardPedido } from './other/DasboardPedido'; 
import { GetExtenso } from './other/GetExtenso'; 
import { ListProdutoVendido } from './list/ListProdutoVendido'; 



// ================== CONTA ==================== //
import { ListConta } from './list/ListConta'; 
import { AddConta } from './add/AddConta'; 
import { AlterConta } from './alter/AlterConta'; 
import { DeleteConta } from './delete/DeleteConta'; 

// ================== EMPRESA ==================== //
import { ListEmpresa } from './list/ListEmpresa'; 
import { AlterEmpresa } from './alter/AlterEmpresa'; 


// ================== DOCUMENTO ==================== //
import { AddDocumento } from './add/AddDocumento'; 
import { ListDocumento } from './list/ListDocumento'; 
 
 
// ================== FACTURA ==================== //
import { ListPedidoFactura } from './list/ListPedidoFactura'; 
import { LisDocumento } from './list/LisDocumento'; 


//======================perfil==================

import {ListPerfil} from './list/ListPerfil';

//===================ESTOQUE==================//
import {AddEstoque} from './add/AddEstoque';
import {ListEstoque} from './list/ListEstoque';
import {ListNome} from './list/ListNome';
import { DeleteEstoque } from './delete/DeleteEstoque'; 
import { AlterEstoque } from './alter/AlterEstoque'; 
import { AlterInventario } from './alter/AlterInventario'; 
import { AlterBaixa } from './alter/AlterBaixa'; 



const Api = {

  Login,
  ListProduto,
  ListCategoria,
  AddProduto,
  AlterProduto,
  DeleteProduto,
  AddCategoria,
  AlterCategoria,
  DeleteCategoria,
  ListMesa,
  AddMesa,
  AlterMesa,
  DeleteMesa,
  ListUserId,
  ListUser,
  AddUser,
  AlterUser,
  DeleteUser,
  CountPedidos,
  ListPedido,
  AlterPedido,
  ListPedidoPorMesa,
  AddPedido,
  AlterQtd,
  MaisVendidos,
  UltimosPedidos,
  DasboardPedido,
  AddConta,
  ListConta,
  AlterConta,
  DeleteConta,
  ListEmpresa,
  AlterEmpresa,
  AddDocumento,
  ListPedidoFactura,
  LisDocumento,
  GetExtenso,
  ListProdutoVendido,
 
ListPedidoMesa,
ListMesaPedido,
FecharPedido,
CancelarPedido,
CancelarPedidoOnly,
PendenteAll,
CheckPedido,
ListPerfil,
 AddEstoque,
 ListEstoque,
 DeleteEstoque,
 AlterEstoque,
 AlterBaixa,
 AlterInventario,
 ListNome,
 EnviarCozinha,
 EntregarProduto,
 ListDocumento,
 ListPedidoCancelado,
 ListPedidoCozinha,
  };


export default Api;